import LoadingButton from '@mui/lab/LoadingButton';
import { Button, FormControl, Grid, MenuItem, Select } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WorkflowContext } from '../contexts/WorkflowProvider';
import { CLIENT_ONBOARD } from '../utils/commonConstants';

const WorkflowNavigateSection = ({
  value,
  loading,
  tabType,
  callDataProcessorFn,
  callRunPreprocessorFn,
  handleClickOpenRuleEngineModal,
  runDataProcessorWorkflow,
  processType,
  processWorkflowType,
}) => {
  ``
  const navigate = useNavigate();
  const { workflow, isDisabled } = useContext(WorkflowContext);

  const val = workflow.process_type === 'Data Ingestion' ? 2 : 1;

  const handleOnCancel = () => {
    // navigate(`/workflow-${processType}`)

    const process_type = processType?.toLowerCase().replace(/\s+/g, '');
    const process_workflow_type = processWorkflowType?.toLowerCase().replace(/\s+/g, '-');

    const url = `/workflow-${process_type}-${process_workflow_type}?processType=${processType}`;
    navigate(url);
  };

  return (
    <Grid container direction="row" display="flex" mt={1}>
      <Grid item xs={6} direction="row" justifyContent="flex-start">
        <Button
          size="small"
          type="submit"
          variant="contained"
          sx={{
            marginRight: '7px',
            marginTop: '7px',
            backgroundColor: '#ffffff',
            '&:hover': { backgroundColor: '#ffffff' },
            color: '#00043C',
            border: '1px solid black',
          }}
          onClick={handleOnCancel}
        >
          {CLIENT_ONBOARD.cancelButton}
        </Button>
      </Grid>
      <Grid item xs={6} display="flex" justifyContent="flex-end">
        <FormControl>
          <Select
            size="small"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={workflow.cloudEnvironment}
            style={{ width: '150px', marginTop: 8, marginRight: 10 }}
            disabled
          >
            <MenuItem value={workflow.cloudEnvironment}>{workflow.cloudEnvironment}</MenuItem>
          </Select>
        </FormControl>
        <LoadingButton
          size="small"
          type="submit"
          variant="outlined"
          loading={loading}
          sx={{
            marginTop: '7px',
            backgroundColor: '#ffffff',
            '&:hover': { backgroundColor: '#ffffff' },
            color: '#00043C',
            border: '1px solid black',
          }}
          onClick={() => {
            tabType === 'preprocessor'
              ? callRunPreprocessorFn()
              : tabType === 'ruleengine'
                ? handleClickOpenRuleEngineModal()
                : runDataProcessorWorkflow();
          }}
          disabled={isDisabled}
        >
          Run
        </LoadingButton>
        {value === 2 && (
          <Button
            size="small"
            type="submit"
            variant="contained"
            sx={{
              marginTop: '7px',
              marginRight: '7px',
              marginLeft: '8px',
              backgroundColor: '#00043C',
              '&:hover': { backgroundColor: '#00043C' },
            }}
            onClick={() => callDataProcessorFn()}
            disabled={isDisabled}
          >
            Save & Submit
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default WorkflowNavigateSection;
